import { render } from "./staffInfoShow.vue?vue&type=template&id=1f45c4cb"
import script from "./staffInfoShow.vue?vue&type=script&lang=js"
export * from "./staffInfoShow.vue?vue&type=script&lang=js"

import "./staffInfoShow.vue?vue&type=style&index=0&id=1f45c4cb&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__